import axios from "axios";

const SAFE_METHODS = ["get", "head", "options"];

const client = axios.create();

client.interceptors.request.use((config) => {
  const token = document.querySelector('meta[name="csrf-token"]')?.content;
  if (token) {
    config.headers["X-CSRF-TOKEN"] = token;
  } else if (!SAFE_METHODS.includes((config.method || "get").toLowerCase())) {
    console.error(
      "[api/client] This page renders no csrf-token meta tag, so this request will be rejected with a 422."
    );
  }
  return config;
});

export default client;
